import { SET_TIMEZOME } from "../actions/constants";

const initialState = {
  timezoneMode: "Europe/London",
};

export default function timezoneReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TIMEZOME:
      return {
        ...state,
        timezoneMode: action.payload,
      };
    default:
      return state;
  }
}
